<template>
  <!-- Navbar -->
  <header class="flex-shrink-0 border-b">
    <div class="flex items-center justify-between p-2">
      <!-- Navbar left -->
      <div class="flex items-center space-x-3">
        <span
          class="p-2 text-xl font-semibold tracking-wider uppercase lg:hidden"
          >V-DN</span
        >
        <!-- Toggle sidebar button -->
        <button
          @click="emit('toggle-sidebar')"
          class="p-2 rounded-md focus:outline-none focus:ring"
        >
          <base-icon
            :iconName="chevronIcon"
            :class="!isSidebarOpen ? 'invert-chevron-icon' : ''"
          />
        </button>
      </div>

      <!-- Navbar right -->
      <div class="relative flex items-center space-x-3">
        <div class="items-center hidden space-x-3 md:flex">
          <notification-button :iconName="notificationIcon" />
        </div>
      </div>
    </div>
  </header>
</template>

<script land='ts'>
// TODO: Add the away directive to dropdown clicks
import NotificationButton from "./NotificationButton.molecule";
import { iconN } from "assets/icons";
import BaseIcon from "components/atoms/BaseIcon.atom.vue";
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  components: { NotificationButton, BaseIcon },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const isSidebarOpen = computed(() => store.getters.isSidebarOpen);
    return {
      emit,
      notificationIcon: iconN.NOTIFICATION,
      chevronIcon: iconN.LFCHEVRON,
      isSidebarOpen,
    };
  },
  emits: ["toggle-is-open", "toggle-sidebar"],
};
</script>

<style scoped>
.invert-chevron-icon {
  transform: rotate(180deg);
}
</style>
